/* eslint-disable @typescript-eslint/no-explicit-any */
import { ReactNode } from 'react';
import { Text as NativeText } from '@mantine/core';
import classes from './Text.module.css';

export const getType = (type: any) => {
	switch (type) {
		case 'subtitle1':
			return classes.subtitle1;
		case 'subtitle2':
			return classes.subtitle2;
		case 'body1':
			return classes.body1;
		case 'body2':
			return classes.body2;
		case 'caption':
			return classes.caption;
		case 'overline':
			return classes.overline;
		default:
			break;
	}
};

export const Text = (props: {
	children: ReactNode;
	type?: string;
	visibleFrom?: string;
	color?: string;
	hiddenFrom?: string;
	className?: string;
	size?: string;
}) => {
	return (
		<NativeText
			className={getType(props.type)}
			{...props}
		>
			{props.children}
		</NativeText>
	);
};
